module.exports = __webpack_public_path__ + "assets/751fa00949b585e7cb7cbcde54b10e6e.svg";